import React from "react";
import ReactApexChart from "react-apexcharts";
import { Col, Row } from "react-bootstrap";

const BarChart = ({ graph }) => {
  const chartData = {
    series: [{ data: graph?.totalData || [], name: "Subject" }],
    options: {
      chart: {
        type: "bar",
        height: 350,
      },
      plotOptions: {
        bar: { horizontal: true, dataLabels: { position: "top" } },
      },
      dataLabels: {
        enabled: false,
      },
      colors: graph?.categoryColor?.map(item => item?.color) ?? [],
      xaxis: {
        categories: graph?.totalCategory || [],
      },
    },
  };

  return (
    <>
      <div
        className="d-flex align-items-center justify-content-between graph__title__border bg-body-secondary"
        style={{ borderBottom: "1px solid rgb(229, 229, 229)" }}
      >
        <h6 className="m-0 fontSize12 fw-bold">
          {graph?.graphName || "Bar Chart"}
        </h6>
      </div>
      <Row>
        <Col md={1} className="chart_yaxis_legend">
          <p className="fw-bold">{graph?.yAxisName}</p>
        </Col>
        <Col md={11}>
          <div id="chart" className="p-0">
            <ReactApexChart
              options={chartData.options}
              series={chartData.series}
              type="bar"
              height={350}
            />
          </div>
          <div className="chart_xaxis_legend">
            <p className="fw-bold">{graph?.xAxisName}</p>
          </div>
        </Col>
      </Row>
    </>
  );
};

export default BarChart;
